"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KillShotAbilityHandler = exports.KillShotActorAbilityFactory = exports.KillShotAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class KillShotAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.KillShot;
        this.__typeName = "KillShot";
    }
}
exports.KillShotAbilityArgs = KillShotAbilityArgs;
let KillShotActorAbilityFactory = class KillShotActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("KillShot", "OneEnemies", 3);
    }
};
KillShotActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("KillShot")
], KillShotActorAbilityFactory);
exports.KillShotActorAbilityFactory = KillShotActorAbilityFactory;
let KillShotAbilityHandler = class KillShotAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let targetIds = ability.args.target.actorIds.slice(0, 1);
        let bp = 75;
        if (container.hasAttribute(ability.invokerId, "Charm_Ranger_1")) {
            targetIds = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
            bp = 60;
        }
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            duration: Duration_1.Duration.EndOfTurn,
            effect: new core_1.UnblockableEffectArgs(),
            onApplied: sequence => {
                container.applyProjectileAttacksWithDamage({
                    sequence,
                    abilityKey: ability.args.__typeName,
                    attackType: "ranged",
                    attackerId: ability.invokerId,
                    projectiles: targetIds.map(targetId => ({
                        path: "line",
                        type: "EvilArrow",
                        targetId,
                        damages: [
                            AbilityDamage_1.AbilityDamage.Power("Chaos", bp),
                            AbilityDamage_1.AbilityDamage.Power("Physical", bp)
                        ]
                    })),
                    onHit(sequence) {
                        container.applyDebuff({
                            sequence,
                            attackerId: ability.invokerId,
                            targetId: selectedEnemy,
                            duration: Duration_1.Duration.Turns(3),
                            effect: new core_1.VulnerabilityEffectArgs(2)
                        });
                    },
                });
            }
        });
    }
};
KillShotAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.KillShot)
], KillShotAbilityHandler);
exports.KillShotAbilityHandler = KillShotAbilityHandler;
